<div class="font-inter">
  <!-- Language Toggle -->
  <div class="w-[95%] max-w-full m-auto flex justify-end mt-4 mb-3">
    <div class="iframe-lang-toggle">
      @if (currentLang === 'en') {
        <button type="button" (click)="setLanguage('sv')" class="lang-btn"
          title="Växla språk">
          <img width="24" height="24" src="assets/img/flag-button-round-250-SV.png">
        </button>
      }
      @if (currentLang === 'sv') {
        <button type="button" (click)="setLanguage('en')" class="lang-btn"
          title="Switch language">
          <img width="24" height="24" src="assets/img/flag-button-round-250-EN.png">
        </button>
      }
    </div>
  </div>

  <section class="w-[95%] max-w-full m-auto flex flex-col gap-3">

    <app-simple-search-select [selectedArrivalDate]="parkingEndTime" [selectedDepartureDate]="parkingStartTime"
    class="flex flex-col gap-3"></app-simple-search-select>

    <mat-form-field class="w-full">
      <mat-label>{{'PARKIFLY.FORM.DISCOUNT_CODE_LABEL' | transloco }}</mat-label>
      <input matInput [formControl]="discountCodeControl">
    </mat-form-field>

    <div class="flex justify-end">
      <button [disabled]="!isContinueButtonEnabled"
        [ngClass]="{'bg-[#397863] text-[#ffffff]' : isContinueButtonEnabled, 'bg-[#dcdcdc] text-[#4B4A4A]': !isContinueButtonEnabled}"
        class="py-5 px-3 rounded-2xl w-full mb-4 text-base transition-colors duration-200"
        (click)="goToBookingForm()">
        <div class="flex gap-2 justify-center items-center">
          {{ (isContinueButtonEnabled ? "PARKIFLY.HOME.CONTINUE" : "FORM.COMPLETE_DETAILS") | transloco}}
          @if (isContinueButtonEnabled) {
            <svg [ngClass]="{'fill-[#ffffff]' : isContinueButtonEnabled}"
              class="w-5 h-5" viewBox="0 0 21 20" xmlns="http://www.w3.org/2000/svg">
              <g id="arrow-narrow-right">
                <path id="Vector" fill-rule="evenodd" clip-rule="evenodd"
                  d="M12.793 5.29303C12.9805 5.10556 13.2348 5.00024 13.5 5.00024C13.7652 5.00024 14.0195 5.10556 14.207 5.29303L18.207 9.29303C18.3945 9.48056 18.4998 9.73487 18.4998 10C18.4998 10.2652 18.3945 10.5195 18.207 10.707L14.207 14.707C14.0184 14.8892 13.7658 14.99 13.5036 14.9877C13.2414 14.9854 12.9906 14.8803 12.8052 14.6948C12.6198 14.5094 12.5146 14.2586 12.5123 13.9964C12.51 13.7342 12.6108 13.4816 12.793 13.293L15.086 11H3.5C3.23478 11 2.98043 10.8947 2.79289 10.7071C2.60536 10.5196 2.5 10.2652 2.5 10C2.5 9.73481 2.60536 9.48046 2.79289 9.29292C2.98043 9.10539 3.23478 9.00003 3.5 9.00003H15.086L12.793 6.70703C12.6055 6.5195 12.5002 6.26519 12.5002 6.00003C12.5002 5.73487 12.6055 5.48056 12.793 5.29303Z">
                </path>
              </g>
            </svg>
          }
        </div>
      </button>
    </div>
  </section>
</div>